import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M34 23v-3m-7.879 6.121L24 24m2.121 18L24 44.121m18-18L44.121 24M23 34h-3m27.729 14.38-4.983 9.254c-.57 1.057-.855 1.586-1.197 1.72a1 1 0 0 1-.901-.088c-.31-.198-.487-.772-.84-1.92L32.89 34.892c-.288-.938-.433-1.407-.317-1.723a1 1 0 0 1 .595-.595c.316-.116.785.029 1.723.317l22.455 6.918c1.148.353 1.722.53 1.92.84a1 1 0 0 1 .088.901c-.134.343-.663.627-1.72 1.197l-9.255 4.983a2 2 0 0 0-.304.181 1 1 0 0 0-.165.165 2 2 0 0 0-.181.304"
    />
  </svg>
);
export default SvgCursor;
